import { AppCard } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { createFileRoute } from "@tanstack/react-router";
import { VendorCategories } from "./-internal_components/VendorCategories";
import { Route as VendorRoute } from "./route";

const RouteComponent: React.FC = () => {
  const vendor = VendorRoute.useLoaderData();

  return (
    <AppCard>
      <VendorCategories vendor={vendor} />
    </AppCard>
  );
};

export const Route = createFileRoute(
  "/_private/vsupplierregistration/vendors/$vendorId/categories",
)({
  component: RouteComponent,
});
